module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_1_1_4.ccdb7531.png";